import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StaffRoutingModule } from './staff-routing.module';
import { EmployeeCategoryComponent } from './employee-category/employee-category.component';
import { StaffUploadComponent } from './staff-upload/staff-upload.component';
import { StaffProfileComponent } from './staff-profile/staff-profile.component';
import { AdminModule } from '../admin/admin.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BsDatepickerModule } from 'ngx-bootstrap';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { StaffDetailsComponent } from './staff-details/staff-details.component';
import { RollNumberGenerationComponent } from './roll-number-generation/roll-number-generation.component';
import { StaffIdCardComponent } from './staff-id-card/staff-id-card.component';
import { PrintStaffIdCardComponent } from './print-staff-id-card/print-staff-id-card.component';



@NgModule({
  declarations: [EmployeeCategoryComponent, StaffUploadComponent, StaffProfileComponent, StaffDetailsComponent, RollNumberGenerationComponent, StaffIdCardComponent, PrintStaffIdCardComponent],
  imports: [
    CommonModule,
    StaffRoutingModule,
    AdminModule,
    FormsModule,
    ReactiveFormsModule,
    BsDatepickerModule.forRoot(),
    NgMultiSelectDropDownModule.forRoot()
  ]
})
export class StaffModule { }
